import script from "./ai-verifier.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-verifier.vue?vue&type=script&setup=true&lang=js"

import "./ai-verifier.vue?vue&type=style&index=0&id=4ee455f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ee455f2"]])

export default __exports__